import { Box } from "@mui/material";
import Header, { HEADER_HEIGHT } from "../general/header/Header";
import PanelsFrame from "./PanelsFrame";
import { colors } from "../../theme";

export default function Dashboard() {
    return (
        <Box sx={{ height: "100vh", display: "flex", flexDirection: "column", backgroundColor: colors.sidebar }}>
            <Header enableSearch={true} />
            <Box sx={{ flexGrow: 1, minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`, overflow: "hidden" }}>
                <PanelsFrame />
            </Box>
        </Box>
    );
}
